import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 cursor-pointer group"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <span className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-movie-2-line text-2xl ${isScrolled || !isHome ? 'text-primary-500' : 'text-white'}`}></i>
            </span>
            <span
              className={`font-heading text-xl whitespace-nowrap ${
                isScrolled || !isHome ? 'text-foreground-950' : 'text-white'
              }`}
            >
              芒果视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.id}
                to={cat.id === 'all' ? '/' : `/category/${cat.id}`}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className={`px-4 py-2 rounded-full text-sm transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  (cat.id === 'all' && isHome) || location.pathname === `/category/${cat.id}`
                    ? 'bg-primary-500 text-white'
                    : isScrolled || !isHome
                    ? 'text-foreground-700 hover:bg-background-200 hover:text-foreground-950'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <div className="hidden md:flex items-center gap-2">
              <Link
                to="/about"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className={`px-4 py-2 rounded-full text-sm transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  location.pathname === '/about'
                    ? 'bg-primary-500 text-white'
                    : isScrolled || !isHome
                    ? 'text-foreground-700 hover:bg-background-200'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                关于我们
              </Link>
              <button
                className={`w-9 h-9 flex items-center justify-center rounded-full transition-all duration-200 cursor-pointer ${
                  isScrolled || !isHome ? 'hover:bg-background-200 text-foreground-700' : 'hover:bg-white/10 text-white/80'
                }`}
                aria-label="搜索"
              >
                <i className="ri-search-line text-lg"></i>
              </button>
            </div>

            <button
              onClick={() => setIsMobileOpen(!isMobileOpen)}
              className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full cursor-pointer ${
                isScrolled || !isHome ? 'text-foreground-700' : 'text-white'
              }`}
              aria-label="菜单"
            >
              <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 space-y-1">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={cat.id === 'all' ? '/' : `/category/${cat.id}`}
                onClick={() => {
                  setIsMobileOpen(false);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-200 cursor-pointer ${
                  (cat.id === 'all' && isHome) || location.pathname === `/category/${cat.id}`
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={cat.icon}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <div className="border-t border-background-200 pt-2 mt-2">
              <Link
                to="/about"
                onClick={() => {
                  setIsMobileOpen(false);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-200 cursor-pointer ${
                  location.pathname === '/about'
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-information-line"></i>
                </span>
                关于我们
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}